import {
  SearchFiltersType,
  SearchItemPostData,
  SearchRequestResultType,
  SearchRequestType,
  SearchStoreType,
} from 'types/nausearchType';
import { ActionType } from 'types/reduxTypes';
import {
  CLEAR_SEARCH_DATA,
  GET_NAUSEARCH_ITEM,
  GET_NAUSEARCH_ITEM_FAILED,
  GET_NAUSEARCH_ITEM_SUCCESS,
  NAUSEARCH_REQUEST,
  NAUSEARCH_REQUEST_FAILED,
  NAUSEARCH_REQUEST_SUCCESS,
  RESET_SEARCH_FORM,
  SET_NAUSEARCH_ITEM,
  SET_NAUSEARCH_REQUEST_MESSAGE,
  SET_SEARCH_FORM,
} from '../constants';

export function clearSearchData(): ActionType<null> {
  return {
    payload: null,
    type: CLEAR_SEARCH_DATA,
  };
}

export function getNauSearchItem(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_NAUSEARCH_ITEM,
  };
}

export function getNauSearchItemSuccess(payload: SearchItemPostData): ActionType<SearchItemPostData> {
  return {
    payload,
    type: GET_NAUSEARCH_ITEM_SUCCESS,
  };
}

export function getNauSearchItemFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_NAUSEARCH_ITEM_FAILED,
  };
}

export function nauSearchRequest(payload: SearchRequestType): ActionType<SearchRequestType> {
  return {
    payload,
    type: NAUSEARCH_REQUEST,
  };
}

export function nauSearchRequestSuccess(payload: SearchRequestResultType): ActionType<SearchRequestResultType> {
  return {
    payload,
    type: NAUSEARCH_REQUEST_SUCCESS,
  };
}

export function nauSearchRequestFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: NAUSEARCH_REQUEST_FAILED,
  };
}

export function setNausearchItem(payload: SearchStoreType['searchItem']): ActionType<SearchStoreType['searchItem']> {
  return {
    payload,
    type: SET_NAUSEARCH_ITEM,
  };
}

export function setNausearchRequestMessage(payload: string): ActionType<string> {
  return {
    payload,
    type: SET_NAUSEARCH_REQUEST_MESSAGE,
  };
}
// SearchForm
export function setSearchForm(payload: Partial<SearchFiltersType>): ActionType<Partial<SearchFiltersType>> {
  return {
    payload,
    type: SET_SEARCH_FORM,
  };
}

export function resetSearchForm(): ActionType<null> {
  return {
    payload: null,
    type: RESET_SEARCH_FORM,
  };
}
